import { Routes, Route } from 'react-router-dom';
import { ArcheLayout } from '../../../components/ArcheLayout';
import { InventoryPage } from './InventoryPage';
import { ItemDetailPage } from './ItemDetailPage';
import { AdminPage } from './AdminPage';

/**
 * Arche wrapper for DFE Inventory — provides ArcheLayout with sidebar
 * and handles sub-routing for all DFE pages.
 */
export function DfeArchePage() {
  return (
    <ArcheLayout>
      <Routes>
        <Route path="/" element={<InventoryPage />} />
        <Route path="/item/:itemId" element={<ItemDetailPage />} />
        <Route path="/admin" element={<AdminPage />} />
      </Routes>
    </ArcheLayout>
  );
}
